module.exports = __webpack_public_path__ + "static/media/step-small-full.18b5847c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-small-full.svg
// module id = 857
// module chunks = 21